import ActionTypes from "./actionTypes";

export function selectedStakeholderChanged(selectedStakeholder) {
  return {
    type: ActionTypes.SELECTED_STAKEHOLDER_CHANGED,
    payload: selectedStakeholder,
  };
}
